<template>
  <div>
    <div class="rm4-card rm4-card--auto-height">
      <InputOverview :show-time="true"></InputOverview>
    </div>
    <div class="rm4-notification-banner">
      <i class="fal fa-info-circle"></i>
      <span>Almost there! Fill in your details below and click "<strong>{{ $store.isVip ? 'Confirm and pay' : 'Confirm and book' }}</strong>" to complete your reservation.</span>
    </div>
    <div class="rm4-card rm4-card--p2-1">
      <div class="rm4-form">
        <div class="rm4-form__input-field">
          <div
            class="rm4-form__input-group"
            :class="{ 'rm4-form__input-group--invalid': error.firstName }"
          >
            <div class="rm4-form__input-label">First name *</div>
            <input
              class="rm4-form__input"
              type="text"
              name="given-name"
              autocomplete="given-name"
              v-model="$store.firstName"
            />
          </div>
          <div
            class="rm4-form__input-group"
            :class="{ 'rm4-form__input-group--invalid': error.lastName }"
          >
            <div class="rm4-form__input-label">Last name *</div>
            <input
              class="rm4-form__input"
              type="text"
              name="family-name"
              autocomplete="family-name"
              v-model="$store.lastName"
            />
          </div>
        </div>
        <div class="rm4-form__input-field">
          <div
            class="rm4-form__input-group"
            :class="{ 'rm4-form__input-group--invalid': error.email }"
          >
            <div class="rm4-form__input-label">Email *</div>
            <input
              class="rm4-form__input"
              type="email"
              name="email"
              autocomplete="email"
              v-model="$store.email"
            />
          </div>
        </div>
        <div class="rm4-form__input-field">
          <div class="rm4-form__input-group">
            <div class="rm4-form__input-label">Phone number *</div>
            <vue-phone-number-input
              class="rm4-form__input"
              name="tel"
              autocomplete="tel"
              default-country-code="NL"
              color="#000000"
              valid-color="#555555"
              error-color="#FF0000"
              :border-radius="0"
              :translations="{
                countrySelectorLabel: '',
                phoneNumberLabel: ''
              }"
              :no-example="true"
              :error="error.phone"
              v-on:update="updatePhone"
              v-model="phone"
            >
            </vue-phone-number-input>
          </div>
        </div>
        <div class="rm4-form__input-label rm4-form__input-label--centered">
          <span>Birthday</span>
          <img
            src="https://www.brandingbeach.nl/img/booking-module-assets/cake.svg"
            alt="cake"
          />
        </div>
        <div class="rm4-form__input-field">
          <div
            class="rm4-form__input-group"
            :class="{
              'rm4-form__input-group--invalid':
                error.birthDay || error.birthDate
            }"
          >
            <input
              class="rm4-form__input rm4-form__input--centered"
              placeholder="DD"
              type="tel"
              name="bday-day"
              autocomplete="bday-day"
              maxlength="2"
              v-model="$store.birthDay"
            />
          </div>
          <span class="rm4-form__dash">-</span>
          <div
            class="rm4-form__input-group"
            :class="{
              'rm4-form__input-group--invalid':
                error.birthMonth || error.birthDate
            }"
          >
            <div class="rm4-form__input-label"></div>
            <input
              class="rm4-form__input rm4-form__input--centered"
              placeholder="MM"
              type="tel"
              name="bday-month"
              autocomplete="bday-month"
              maxlength="2"
              v-model="$store.birthMonth"
            />
          </div>
          <span class="rm4-form__dash">-</span>
          <div
            class="rm4-form__input-group"
            :class="{
              'rm4-form__input-group--invalid':
                error.birthYear || error.birthDate
            }"
          >
            <div class="rm4-form__input-label"></div>
            <input
              class="rm4-form__input rm4-form__input--centered"
              placeholder="YYYY"
              type="tel"
              name="bday-year"
              autocomplete="bday-year"
              maxlength="4"
              v-model="$store.birthYear"
            />
          </div>
        </div>
        <div class="rm4-form__input-field">
          <div class="rm4-form__input-group">
            <div class="rm4-form__input-label">Postcode</div>
            <input
              class="rm4-form__input"
              type="text"
              name="postal-code"
              autocomplete="postal-code"
              pattern="[a-zA-Z0-9]+"
              maxlength="25"
              v-model="$store.zipCode"
            />
          </div>
        </div>
        <div class="rm4-form__input-field">
          <div class="rm4-form__input-group">
            <div class="rm4-form__custom-check">
              <label
                class="rm4-form__custom-check__label"
                for="keep-informed-checkbox"
              >
                <input
                  id="keep-informed-checkbox"
                  class="rm4-form__input"
                  type="checkbox"
                  v-model="$store.keepInformed"
                />
                <div class="rm4-form__input-label">Keep me informed</div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-show="$store.loading" class="rm4-loader"></div>
    </div>

    <div class="rm4-actions">
      <div
        class="rm4-button rm4-button--primary"
        :class="{ 'rm4-button--disabled': $store.loading }"
        @click="validate"
      >
        {{ $store.isVip ? "Confirm and pay" : "Confirm and book" }}
      </div>
      <div
        class="rm4-button"
        :class="{ 'rm4-button--disabled': $store.loading }"
        @click="$modal.show('rm4-not-complete-modal')"
      >
        <i class="fal fa-chevron-left"></i> Back
      </div>
    </div>

    <div class="rm4-card__sub-label rm4-mt-2">
      When you reserve a table you agree to our
      <a target="_blank" href="/nl/privacy/">Terms and Conditions</a>. You
      will receive a confirmation email.
    </div>

    <modal
      name="rm4-vip-check-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container">
        <div
          class="rm4-modal-close"
          @click="$modal.hide('rm4-vip-check-modal')"
        >
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div class="text">
          The selected date/time is no longer available. Please select other
          date/time.
        </div>
      </div>
    </modal>

    <modal
      name="rm4-not-complete-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container">
        <div
          class="rm4-modal-close"
          @click="$modal.hide('rm4-not-complete-modal')"
        >
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div>
          Your reservation is NOT complete! Are you sure you want to move away
          from this step?
        </div>
        <div class="rm4-actions rm4-actions--modal">
          <div
            class="rm4-button rm4-button--tertiary"
            @click="$store.currentStep = $step.THIRD"
          >
            Yes
          </div>
          <div
            class="rm4-button"
            @click="$modal.hide('rm4-not-complete-modal')"
          >
            No
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="rm4-info-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container rm4-modal-container--centered">
        <div class="rm4-modal-close" @click="$modal.hide('rm4-info-modal')">
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div class="text" v-html="modalData"></div>
        <button
          class="rm4-button rm4-button--primary rm4-mt-1"
          @click="$store.currentStep = $step.FIRST"
        >
          Back
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import VuePhoneNumberInput from "vue-phone-number-input";
import InputOverview from "./InputOverview";

export default {
  name: "CustomerInfo",
  components: {
    InputOverview,
    VuePhoneNumberInput
  },
  data: function() {
    return {
      phone: this.$store.phone,
      error: {
        email: false,
        firstName: false,
        lastName: false,
        phone: false,
        birthDay: false,
        birthMonth: false,
        birthYear: false,
        birthDate: false
      },
      modalData: null,
    };
  },
  methods: {
    updatePhone(value) {
      this.$store.phone = _.get(value, "formattedNumber");
      _.set(
        this.error,
        "phone",
        !_.get(value, "isValid") || this.$store.phone === "+31612345678"
      );
    },
    validate() {
      _.set(this.error, "email", !this.isValidEmail());
      _.set(this.error, "firstName", !this.$store.firstName);
      _.set(this.error, "lastName", !this.$store.lastName);

      if (!this.$store.phone) {
        _.set(this.error, "phone", true);
      }

      if (
        this.$store.birthDay ||
        this.$store.birthMonth ||
        this.$store.birthYear
      ) {
        let birthDay = moment(this.padded(this.$store.birthDay), "DD", true);
        let birthMonth = moment(
          this.padded(this.$store.birthMonth),
          "MM",
          true
        );
        let birthYear = moment(this.$store.birthYear, "YYYY", true);

        _.set(
          this.error,
          "birthDay",
          !this.$store.birthDay || !birthDay.isValid()
        );
        _.set(
          this.error,
          "birthMonth",
          !this.$store.birthMonth || !birthMonth.isValid()
        );
        _.set(
          this.error,
          "birthYear",
          !this.$store.birthYear || !birthYear.isValid()
        );

        if (this.isValid(["birthDay", "birthMonth", "birthYear"])) {
          birthDay = birthDay.format("DD");
          birthMonth = birthMonth.format("MM");
          birthYear = birthYear.format("YYYY");

          const date = `${birthYear}-${birthMonth}-${birthDay}`;
          const isSameOrAfter = moment(date, "YYYY-MM-DD").isSameOrAfter(
            moment()
          );

          _.set(this.error, "birthDate", isSameOrAfter);

          if (!isSameOrAfter) {
            this.$store.birthdate = date;
          }
        }
      } else {
        _.set(this.error, "birthDay", false);
        _.set(this.error, "birthMonth", false);
        _.set(this.error, "birthYear", false);
        _.set(this.error, "birthDate", false);
      }

      if (this.isValid()) {
        this.proceed();
      }
    },
    async proceed() {
      this.$store.loading = true;

      try {
        this.setFpData(3, 0, this.$domain);
        const url = `${this.$apiHost}?nocache=${new Date().getTime()}`;
        const payload = new FormData();
        payload.append("action", "validate_booking");
        payload.append(
          "datetime",
          `${moment(this.$store.date).format("YYYY-MM-DD")} ${this.$store.time}`
        );
        payload.append("name", this.name);
        payload.append("phone", this.$store.phone);
        payload.append("email", this.$store.email);
        payload.append("domain", this.$domain);
        payload.append("isLog", true);
        payload.append("tag", this.$store.tag);

        const response = await axios.post(url, payload);

        if (_.get(response, "data.error")) {
          this.$modal.show("rm4-vip-check-modal");
          this.$store.loading = false;
          return;
        }

        const action = "&action=check_special";
        const domain = `&domain=${this.$domain}`;
        const pax = `&totalpax=${this.$store.adults + this.$store.kids}`;
        const date = `&date=${moment(this.$store.date).format("YYYY-MM-DD")}`;
        const time = `&time=${this.$store.time}`;
        const { data } = await axios.get(
          `${url}${action}${domain}${pax}${date}${time}`
        );

        if (this.$store.isVip && !_.get(data, "specialmaxpax")) {
          this.$modal.show("rm4-vip-check-modal");
          this.$store.loading = false;
          return;
        }

        await this.saveDataLog({
          step: 3,
          firstname: this.$store.firstName,
          lastname: this.$store.lastName,
          email: this.$store.email,
          phone: this.$store.phone,
          bookdate: moment(this.$store.date).format("YYYY-MM-DD"),
          adult: this.$store.adults,
          children: this.$store.kids,
          booktime: this.$store.time,
          zipcode: this.$store.zipCode,
          birthday: this.$store.birthdate,
          inform: this.$store.keepInformed ? 1 : 0
        });

        this.save();
      } catch (error) {
        console.error(error);
        this.$store.loading = false;
      }
    },
    async save() {
      this.$store.loading = true;

      try {
        const url = `${this.$apiHost}?nocache=${new Date().getTime()}`;
        const payload = {
          action: "booking",
          bookdate: moment(this.$store.date).format("YYYY-MM-DD"),
          booktime: this.$store.time,
          endtime: this.$store.endTime,
          adults: this.$store.adults,
          kids: this.$store.kids,
          bookname: this.name,
          bookemail: this.$store.email,
          bookphone: this.$store.phone,
          zipcode: this.$store.zipCode
            ? this.$store.zipCode.replace(/[^0-9a-z]/gi, "").toUpperCase()
            : null,
          birthday: this.$store.birthdate,
          domain: this.$domain,
          isSpecialBooking: Number(this.$store.isVip),
          send_sms_confirmation: 1,
          inform: this.$store.keepInformed,
          isLog: true,
          fp_fp2: this.$store.fpFp2,
          fp_guid: this.$store.fpGuid,
          existing: false,
          frame: this.getFrame(),
          pf: this.$store.isPreferredCustomer,
          pf_timeslot: this.$store.isPreferredTimeslot,
          isOutside: this.$store.isOutside,
          comment: this.$store.isOutside ? "Outside" : "",
          vue_app: 1,
          tag: this.$store.tag
        };
        const { data } = await axios.post(url, payload);

        await this.saveDataLog({
          step: 4,
          firstname: this.$store.firstName,
          lastname: this.$store.lastName,
          email: this.$store.email,
          phone: this.$store.phone,
          bookdate: moment(this.$store.date).format("YYYY-MM-DD"),
          adult: this.$store.adults,
          children: this.$store.kids,
          booktime: this.$store.time,
          zipcode: this.$store.zipCode,
          birthday: this.$store.birthdate,
          inform: this.$store.keepInformed,
          confirmed: true
        });

        if (_.get(data, "error") && _.get(data, "description")) {
          this.modalData = _.get(data, "description");
          this.$modal.show("rm4-info-modal");
          this.$store.loading = false;
          this.setFpData(3, 1, this.$domain);
          return;
        }

        if (this.$store.isVip) {
          this.setFpData(4, 0, this.$domain);

          if (_.get(data, "isMolliePayment")) {
            window.location.href = _.get(data, "paymentUrl");
            return;
          }

          this.adyenFormAction = _.get(data, "paymentUrl");
          const paymentData = _.get(data, "paymentData");

          _.forIn(paymentData, function(value, key) {
            this.adyenFormInputs.push({
              type: "hidden",
              name: key,
              value
            });
          });

          setTimeout(() => this.$refs.adyenForm.submit(), 1000);
          return;
        }

        this.setFpData(4, 0, this.$domain);
        this.googleEventLog();
        this.fbPixelLog("successNormal");
        this.$store.completeDesc = _.get(data, "description");
        this.$store.currentStep = this.$step.FIFTH;
      } catch (error) {
        console.error(error);
      }

      this.$store.loading = false;
    },
    getFrame() {
      return {
        start: moment(
          `${moment(this.$store.date).format("YYYY-MM-DD")} ${
            this.$store.frame.time_from
          }`
        ).format("YYYY-MM-DD HH:mm:ss"),
        end: moment(
          `${moment(this.$store.date).format("YYYY-MM-DD")} ${
            this.$store.frame.time_to
          }`
        ).format("YYYY-MM-DD HH:mm:ss")
      };
    },
    googleEventLog() {
      if (typeof gtag === "function") {
        gtag( // eslint-disable-line no-undef
          "event",
          "booking",
          {
            event_category: "booking",
            event_label: "booking success"
          }
        );
      }
    },
    fbPixelLog(state) {
      let action = "";

      switch (state) {
        case "successNormal":
          action = "ReservationNormal";
          break;
        case "successVip":
          action = "ReservationCorona";
          break;
        case "failVip":
          action = "ReservationFail";
          break;
      }

      if (typeof fbq === "function") {
        fbq("trackCustom", action, { // eslint-disable-line no-undef
          custom_param1: "1"
        });
      }
    },
    padded(value, length = 2) {
      return value ? String(value).padStart(length, "0") : value;
    },
    isValid(keys) {
      const errors = keys ? _.pick(this.error, keys) : this.error;

      return _.values(errors).every(e => e === false);
    }
  },
  computed: {
    name: function() {
      return `${this.$store.firstName} ${this.$store.lastName}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.rm4-notification-banner {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.6rem;
  margin-bottom: 0.25rem;
  background: linear-gradient(135deg, #e8f4fd 0%, #d6ebf9 100%);
  border: 1px solid #b8daef;
  border-radius: 0.4rem;
  color: #1a5a7a;
  font-size: 12px;
  line-height: 1.3;

  i {
    font-size: 14px;
    color: #2196F3;
    flex-shrink: 0;
  }

  span {
    flex: 1;
  }

  strong {
    color: #0d4a6f;
  }
}

.rm4-form__input-label {
  width: inherit;
  color: grey;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  margin-bottom: 0.2rem;

  &.rm4-form__input-label--centered {
    display: flex;
    align-items: center;
  }

  img {
    width: 16px;
    height: 16px;
    margin-left: 5px;
    align-self: flex-start;
  }
}

.rm4-form {
  padding: 0.5rem 0.5rem 0;

  .rm4-form__input-field {
    display: flex;
    margin: 0 -0.5rem 0.5rem;
    align-items: flex-end;

    &:last-child {
      margin-bottom: 0;
    }

    .rm4-form__input-group {
      width: 100%;
      margin: 0 0.5rem 0.5rem;

      &.rm4-form__input-group--invalid {
        & * {
          color: red !important;
          border-color: red !important;
        }
      }

      .rm4-form__input {
        width: inherit;
        height: 34px;
        font-size: 16px;
        color: #555;
        border-width: 0 0 1px 0;
        border-color: #ccc;
        border-radius: 0;

        &.rm4-form__input--centered {
          text-align: center;
          font-size: 14px;
        }
      }

      .rm4-form__custom-check {
        display: flex;
        align-items: center;

        .rm4-form__custom-check__label {
          display: flex;

          .rm4-form__input {
            height: 14px;
            margin: 0 8px 0 0;
          }
        }
      }
    }

    .rm4-form__dash {
      align-self: center;
    }
  }
}

.rm4-card__sub-label {
  a {
    color: #8a927c !important;
  }
}

.rm4-mt-2 {
  margin-top: 32px;
}

.rm4-card {
  margin-bottom:10px;
}
</style>
